module.exports = __webpack_public_path__ + "media/images/riders/MORGAN_CHARRE-33fb9525a147c2f3e5a4725f451e7c4a.png";